export const SELECTED_APMC_NAME_KEY = "selectedApmcName";
export const CURRENT_DATE_KEY = "currentDate";
export const PREFERRED_ASIN_KEY = "preferredAsin";

export const LOCALHOST = "http://localhost:4321";
export const BETA = "d2601l29lgewiy.cloudfront.net";
export const GAMMA_ZAZ = "d2k329ve3ejz4.cloudfront.net";
export const PROD_ZAZ = "d1vwo9bmmju4k4.cloudfront.net"
export const STAGES = ["test", "beta", "gamma-zaz", "prod-zaz"];
